<div *ngIf="useWhatsApp" class="my-3 d-flex">
  <label class="form-check-label ml-4">
    <input
      type="checkbox"
      class="form-check-input"
      [(ngModel)]="whatsAppOptInChecked"
      (change)="change()"
    /> Send my notifications via WhatsApp
  </label>
</div>

<div class="my-3 d-flex">
  <label class="form-check-label ml-4">
    <input
      type="checkbox"
      class="form-check-input"
      [(ngModel)]="checked"
      (ngModelChange)="change()"
    />
    I agree to receive {{providerName}} notifications about my {{optinType}}. Text STOP to opt out. Text HELP for info. Message and
    data rates may apply. Message frequency varies.
    <ng-container>
      <a href="https://www.tablesready.com/terms.html" target="_blank">Terms</a> and
      <a href="https://www.tablesready.com/privacy.html"target="_blank">privacy policy</a> apply.
    </ng-container>
  </label>
</div>
